import store from '@state/store'
import { computed } from 'vue'

const currentCampusScope = computed(() => store?.state?.layout?.currentCampusScope)
const currentClassScope = computed(() => store?.state?.layout?.currentClassScope)
const currentSectionScope = computed(() => store?.state?.layout?.currentSectionScope)

export const getCurrentScopeFlags = () => {
  const isCampusLevel =
    !!currentCampusScope.value && !currentClassScope.value && !currentSectionScope.value
  const isClassLevel =
    !!currentCampusScope.value && !!currentClassScope.value && !currentSectionScope.value
  const isSectionLevel =
    !!currentCampusScope.value && !!currentClassScope.value && !!currentSectionScope.value
  return { isCampusLevel, isClassLevel, isSectionLevel }
}
